'use client';

import { Container } from '@coolblue-development/freddy';
import type { ReactNode } from 'react';

const ComparisonContainer = ({ children }: { children: ReactNode }) => (
  <Container
    fullWidthUntil='lg'
    sx={{
      overflow: 'auto'
    }}
    component='main'
  >
    <Container
      sx={theme => ({
        [theme.breakpoint.maxWidth('lg')]: {
          paddingRight: '0 !important'
        },
        '--comparison-column-width': 'calc(50vw - 0.8rem)',
        [theme.breakpoint.minWidth('sm')]: { '--comparison-column-width': 'calc(50vw - 1.6rem)' },
        [theme.breakpoint.minWidth('md')]: { '--comparison-column-width': '25.6rem !important' }
      })}
    >
      {children}
    </Container>
  </Container>
);

export default ComparisonContainer;
